import { FunctionComponent, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@store/store";
import { TextHeadingWithBody } from "@ui-kit/TextHeadingWithBody/TextHeadingWithBody";
import dayjs from "dayjs";
import { ConfigProvider } from "@ui-kit/ConfigProvider";
import {
  selectTripDuration,
  setTripDuration,
  setCurrentStep,
} from "@store/tripBuilder/tripBuilderReducer";
import { ModalNavFooter } from "@ui-kit/Modal/ModalNavFooter";
import { BaseDatePicker } from "@ui-kit/DatePicker/BaseDatePicker";
const TripBuilderTripDuration: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const goNext = useCallback(() => {
    dispatch(setCurrentStep("groupComposition"));
  }, [dispatch]);

  const tripDuration = useAppSelector(selectTripDuration);
  // let dayDuration;
  let startsOn;
  let endsOn;

  if (tripDuration) {
    if ("startsOn" in tripDuration) {
      startsOn = tripDuration.startsOn;
      endsOn = tripDuration.endsOn;
    } else {
      // dayDuration = tripDuration.dayDuration;
    }
  }

  const handleDateRangeChange = useCallback(
    (dates: [start: dayjs.Dayjs | null, end: dayjs.Dayjs | null] | null) => {
      const startsOn = dates?.[0]?.toISOString().split("T")[0];
      const endsOn = dates?.[1]?.toISOString().split("T")[0];
      if (startsOn && endsOn) {
        dispatch(
          setTripDuration({
            startsOn,
            endsOn,
          }),
        );
      }
    },
    [dispatch],
  );

  const value = useMemo(():
    | [start: dayjs.Dayjs | null, end: dayjs.Dayjs | null]
    | null => {
    if (!startsOn && !endsOn) {
      return null;
    }
    return [startsOn ? dayjs(startsOn) : null, endsOn ? dayjs(endsOn) : null];
  }, [startsOn, endsOn]);

  return (
    <>
      <div className="trip-builder-container">
        <div className="trip-duration">
          <TextHeadingWithBody
            headingText={t("screens.tripBuilder.tripDuration.heading")}
            bodyText={t("screens.tripBuilder.tripDuration.subheading")}
            headingSize="Xlarge"
            bodySize="Large"
            align="center"
            gap={8}
          />
          <ConfigProvider type="client">
            <BaseDatePicker
              value={value}
              onChange={handleDateRangeChange}
              size="large"
            />
          </ConfigProvider>
        </div>
      </div>
      <ModalNavFooter
        canGoBack={false}
        onNext={goNext}
        nextDisabled={!startsOn || !endsOn}
      />
    </>
  );
};

export { TripBuilderTripDuration };
